export const VIRUS_STATUS = Object.freeze({
  STATUS_NOT_SCANNED: 'not_scanned',
  STATUS_SCANNING: 'scanning',
  STATUS_SCAN_PASSED: 'scanned',
  STATUS_SCAN_FAILED: 'failed_scan',
  STATUS_EMPTY: '',
})

export const FILE_SIZE_LIMIT = 5368000000;
export const FILE_SIZE_TEXT_LIMIT = "5GB";

export const PREVIEWABLE_FILE_TYPES = {
  csv: true,
  doc: true,
  docm: true,
  docx: true,
  dot: true,
  dotm: true,
  dotx: true,
  eml: true,
  fodg: true,
  fodp: true,
  fods: true,
  fodt: true,
  htm: true,
  html: true,
  msg: true,
  odf: true,
  odg: true,
  odp: true,
  ods: true,
  odt: true,
  otg: true,
  otp: true,
  ots: true,
  ott: true,
  pdf: true,
  pot: true,
  potm: true,
  potx: true,
  pps: true,
  ppsm: true,
  ppsx: true,
  ppt: true,
  pptm: true,
  pptx: true,
  rtf: true,
  svg: true,
  txt: true,
  vsd: true,
  vsdm: true,
  vsdx: true,
  vdx: true,
  xhtm: true,
  xhtml: true,
  xls: true,
  xlsm: true,
  xlsx: true,
  xlt: true,
  xltm: true,
  xltx: true,
  bmp: true,
  cur: true,
  dib: true,
  gif: true,
  ico: true,
  jp2: true,
  jpc: true,
  jpeg: true,
  jpg: true,
  pbm: true,
  pgm: true,
  png: true,
  ppm: true,
  psb: true,
  psd: true,
  tif: true,
  tiff: true,
};

export const fileEditingAllowedList = [
  'pdf',
  'doc',
  'docx',
  'xls',
  'xlsx',
  'odt',
  'ods',
  'csv',
];


export const FILTER_PREFIXES = {
  CONTACTS: 'CON',
  INTERNAL: 'TENANT',
  MY_FILES: 'USR',
  RECENTS: 'RECENTS',
};

export const CONVERTIBLE_EXTENSIONS = {
  pdf: true,
  doc: true,
  docx: true,
  ppt: true,
  pptx: true,
  xlsx: true,
  bmp: true,
  emf: true,
  gif: true,
  jp2: true,
  tif: true,
  tiff: true,
  txt: true,
  xod: true,
  xps: true,
  jpeg: true,
  jpg: true,
  png: true,
  svg: true,
  csv: true,
  eml: true,
  html: true,
  msg: true,
  ods: true,
  odt: true,
  rtf: true,
  xls: true,
  xlsm: true,
  htm: true,
};
